import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const LiveClock = ({ className = "" }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Clock className="h-4 w-4" />
      <span>
        {currentTime.toLocaleDateString('en-IN', {
          weekday: 'long',
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        })} • {currentTime.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })}
      </span>
    </div>
  );
};

export default LiveClock;
